import React, {Component} from "react";
import Select from "react-select";


class SearchOrderInput extends Component {
    state = {
        "order_flag": this.props.orderFlag,
        "search_order_types": [
            {value: 0, label: 'Auto', color: '#9999FF'},
            {value: 1, label: 'Rating', color: '#9999FF'},
            {value: 2, label: 'Alphabetical', color: '#9999FF'},
            {value: 3, label: 'Design Problem Word Frequency', color: '#9999FF'},
            {value: 4, label: 'Pattern Description Word Frequency', color: '#9999FF'},
            {value: 5, label: 'Exercise', color: '#9999FF'}]
    };


    orderFlagToIndex = (order_flag) => {
        switch (order_flag) {
            case 'pattern_rating':
                return 1
            case 'pattern_name':
                return 2
            case 'problem_word_count':
                return 3
            case 'description_word_count':
                return 4
            case 'pattern_exercise':
                return 5
            default:
                return 0
        }
    }

    indexToOrderFlag = (index) => {
        switch (index) {
            case 1:
                return 'pattern_rating'
            case 2:
                return 'pattern_name'
            case 3:
                return 'problem_word_count'
            case 4:
                return 'description_word_count'
            case 5:
                return 'pattern_exercise'
            default:
                return 'auto'
        }
    }

    render() {
        return(
            <span key={"orderBySelector"} style={{marginLeft: 5, width: '100%', maxWidth: 300, zIndex: 90}}>
                <Select
                    isSingle
                    options={this.state.search_order_types}
                    defaultValue={this.state.search_order_types[this.orderFlagToIndex(this.state.order_flag)]}
                    closeMenuOnSelect={true}
                    placeholder="Choose how you want to order the list"
                    onChange={(val) => {
                        this.setState({order_flag: this.indexToOrderFlag(val.value)});
                        this.props.updatOrderBy(this.indexToOrderFlag(val.value))
                    }}
                />
            </span>
        );
    }
}

export default SearchOrderInput;